module.exports = __webpack_public_path__ + "static/media/reload.a8c82a51.svg";